import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User } from '../_models/user';
import { Observable } from 'rxjs';


@Injectable()
export class AuthService {
  constructor(
    private http: HttpClient
  ) { }

  get currentUser(): User {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  saveCurrentUser(user: User) {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  // Register
  doRegister(value) {
    return new Promise<any>((resolve, reject) => {
      this.http.post(environment.drupal.apiBaseUrl + '/rest/create-account?_format=json',
        {
          mail: value.email,
          pass: value.password
        }
      ).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  // Validate registration
  doValidate(value) {
    return new Promise<any>((resolve, reject) => {
      this.http.post(environment.drupal.apiBaseUrl + '/rest/verify-account?_format=json',
        {
          name: value.email,
          temp_token: value.code
        }
      ).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  // Login
  doLogin(value) {
    let data = new FormData();
    data.set('grant_type', 'password');
    data.set('client_id', environment.drupal.oauthClient);
    data.set('client_secret', environment.drupal.oauthSecret);
    data.set('username', value.email);
    data.set('password', value.password);
    return new Promise<any>((resolve, reject) => {
      this.http.post(environment.drupal.apiBaseUrl + '/oauth/token', data).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  // Request password recovery
  doRecoverPassword(email: string) {
    return new Promise<any>((resolve, reject) => {
      this.http.get(environment.drupal.apiBaseUrl + `/api/user/reset/${email}`).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  // Reset password
  doResetPassword(value) {
    let data = {
      uid: value.uid,
      timestamp: value.timestamp,
      hash: value.token,
      new_password: value.password
    };
    return new Promise<any>((resolve, reject) => {
      this.http.post(environment.drupal.apiBaseUrl + '/api/user/reset/password/', data).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  // Logout
  doLogout() {
    return new Promise<void>((resolve, reject) => {
      localStorage.removeItem('currentUser');
      localStorage.removeItem('remember');
      resolve();
    });
  }

  // Refresh token
  doRefreshToken(refresh_token: string): Observable<any> {
    let data = new FormData();
    data.set('grant_type', 'refresh_token');
    data.set('client_id', environment.drupal.oauthClient);
    data.set('client_secret', environment.drupal.oauthSecret);
    data.set('refresh_token', refresh_token);

    return this.http.post<any>(`${environment.drupal.apiBaseUrl}/oauth/token`, data);
  }

  // Is refreshing token URL
  isRefreshingTokenUrl(url: string): boolean {
    return url.endsWith('oauth/token');
  }

  // Gest current user info
  getUserInfo(access_token: string) {
    return new Promise<any>((resolve, reject) => {
      let headers = new HttpHeaders({ "Authorization": "Bearer " + access_token });
      this.http.get(environment.drupal.apiBaseUrl + '/oauth/userinfo', { headers }).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }
}
